import { takeEvery, takeLatest } from 'redux-saga/effects';
import { SESSION_MODULE } from '../../../configs/moduleNames';
import { DOWNLOAD_SESSION, LOAD_SESSION_LIST } from '../actions';

import loadSessionList from './loadSessionList';
import downloadSession from './downloadSession';

export default function* watchDashboard() {
  yield takeLatest(SESSION_MODULE + LOAD_SESSION_LIST, loadSessionList);
  yield takeLatest(SESSION_MODULE + DOWNLOAD_SESSION, downloadSession);
}
